























































































































































import Vue from 'vue';
import { ErrorCodes } from '@ringana/errors';
import BlogSection from '@/components/newsingleproductpage/subcomponents/BlogSection.vue';
import CartHelper from '@/helpers/CartHelper';
import IdealSupplementsSection from '@/components/newsingleproductpage/subcomponents/IdealSupplementsSection.vue';
import { IBlogPostsData } from '@/common/interfaces/blog.interface';
import {
  IDescriptionSectionData,
  IExtendedSingleProductData,
  INewSingleProductData,
  IProduct,
  IProductAward,
  IProductDetails,
  IProductVariant,
  ITab,
  IVideo,
} from '@/common/interfaces/products.interface';
import FetchHelper from '@/helpers/OldFetchHelper';
import config from '../../../config';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';
import LoadingSpinner from '@/components/common/loading/LoadingSpinner.vue';
import CookieHelper from '@/helpers/CookieHelper';
import CustomerHelper from '@/helpers/CustomerHelper';
import VideoSection from '@/components/newsingleproductpage/subcomponents/VideoSection.vue';
import DescriptionSection from '@/components/newsingleproductpage/subcomponents/DescriptionSection.vue';
import ProductPageValuesSection from '@/components/newsingleproductpage/subcomponents/ProductPageValuesSection.vue';
import SingleProductDetailsBar from '@/components/newsingleproductpage/subcomponents/SingleProductDetailsBar.vue';
import TopSection from '@/components/newsingleproductpage/subcomponents/TopSection.vue';
import ProductHelper from '@/helpers/ProductHelper';
import { IShoppingCartIndividual } from '@/common/interfaces/cart.interface';
import MerchandiseOverlay from '@/components/common/merchandise-overlay/MerchandiseOverlay.vue';
import {
  IMerchandiseItem,
  IMerchandiseOverlayOptions,
} from '@/common/interfaces/merchandise.interface';
import Accordion from '@/components/common/accordion/Accordion.vue';
import AccordionItem from '@/components/common/accordion/AccordionItem.vue';
import { ILimitingObject, ILimitingPosition } from '@/common/interfaces/limiting.interface';
import EventListenerHelper from '@/helpers/EventListenerHelper';
import TrackingHelper from '@/helpers/TrackingHelper';
import { EProductType } from '../../common/enums/index.enum';
import ApplicationError from '@/errors/application-error';

interface INewSingleProductPageComponent {
  availableCarts: IShoppingCartIndividual[];
  blogPosts: IBlogPostsData[];
  descriptionData: IDescriptionSectionData | null;
  isPartner: boolean;
  limiting: ILimitingObject;
  merchandiseOverlay: IMerchandiseOverlayOptions;
  pageLoading: boolean;
  productDetails: IProductDetails | null;
  productInfos: IProduct[];
  productNotFound: boolean;
  selectedCartId: number;
  singleProductData: INewSingleProductData;
  video: IVideo | null;
  zapiProductData: IProduct | null;
}

export default Vue.extend({
  name: `NewSingleProductPage`,
  components: {
    Accordion,
    AccordionItem,
    BlogSection,
    DescriptionSection,
    IdealSupplementsSection,
    LoadingSpinner,
    MerchandiseOverlay,
    ProductPageValuesSection,
    SingleProductDetailsBar,
    TopSection,
    VideoSection,
  },
  data(): INewSingleProductPageComponent {
    return {
      availableCarts: [],
      blogPosts: [],
      descriptionData: null,
      isPartner: false,
      limiting: {
        active: false,
        documentEventListeners: [],
        position: {
          current: -1,
          list: `ll`,
          total: -1,
        },
        shoppingAllowed: true,
      },
      merchandiseOverlay: {
        isBusinessCard: false,
        isCarDecal: false,
        item: null,
        loading: false,
        mutation0Error: false,
        visible: false,
      },
      pageLoading: true,
      productDetails: null,
      productInfos: [],
      productNotFound: false,
      selectedCartId: -1,
      singleProductData: {
        awards: null,
        blogPostsIds: [],
        categories: [],
        descriptionImageId: 0,
        disruptor: {
          id: 0,
          mediaId: 0,
        },
        faqs: [],
        idealSupplements: [],
        informationLinkColor: ``,
        isCosmeticsProduct: false,
        productVariants: [],
        shortDescription: ``,
        tabs: [],
        teaserDots: [],
        title: ``,
        unitPriceData: {
          amount: null,
          type: null,
        },
        usp: ``,
        values: [],
      },
      video: null,
      zapiProductData: null,
    };
  },
  computed: {
    discountActive(): boolean {
      return !!(this.isPartner ? this.zapiProductData?.prices.partner.discountPercentage : this.zapiProductData?.prices.customer.discountPercentage);
    },
    filteredAwards(): IProductAward[] {
      if(!this.singleProductData.awards) {
        return [];
      }

      return Object.values(this.singleProductData.awards).filter(award => award.received === `1`);
    },
    filteredTabs(): ITab[] {
      return this.singleProductData.tabs.filter(tab => !!tab.description);
    },
  },
  async created(): Promise<void> {
    await this.fetchSingleProductData();
  },
  beforeMount(): void {
    this.limiting.documentEventListeners = [
      { callback: this.updateLimitingActive, name: `rin-limiting-active` },
      { callback: this.updateLimitingActive, name: `rin-limiting-still-active` },
      { callback: this.updateLimitingNotActive, name: `rin-limiting-not-active` },
      { callback: this.updateLimitingPosition, name: `rin-limiting-position-update` },
      { callback: this.updateLimitingNotActive, name: `rin-limiting-request-with-deactivated-bouncer` },
      { callback: this.updateShoppingAllowed, name: `rin-limiting-shopping-allowed` },
      { callback: this.updateShoppingDisallowed, name: `rin-limiting-shopping-disallowed` },
    ];
  },
  async mounted(): Promise<void> {
    EventListenerHelper.setUpEventListeners(this.limiting.documentEventListeners);
    await this.setUp();

    if(!this.productDetails || !this.zapiProductData) {
      return;
    }

    const productPrice = ProductHelper.getPriceUnformatted(this.isPartner, this.zapiProductData.prices);
    TrackingHelper.trackProductView(
      this.productDetails.matchcode,
      this.productDetails.title,
      (this.productDetails.categories.find(category => category.primary)?.name ?? ``),
      typeof productPrice === `string` ? -1 : parseFloat(productPrice.toFixed(2)),
    );
  },
  beforeDestroy(): void {
    EventListenerHelper.teardownEventListeners(this.limiting.documentEventListeners);
  },
  methods: {
    areAllRequiredFieldsFilledOut(): boolean {
      this.merchandiseOverlay.mutation0Error = false;
      if(!this.merchandiseOverlay.item?.tempMutations[0].value) {
        this.merchandiseOverlay.mutation0Error = true;
        this.$swal(``, this.$t(`products-overview:line0Empty`), `warning`);
        return false;
      }
      return true;
    },
    closeMerchandiseOverlay(clearData = true): void {
      if(clearData) {
        this.setTemporaryMerchandiseOverlayMutations();
      }

      this.merchandiseOverlay.item = null;
      this.merchandiseOverlay.visible = false;
      this.merchandiseOverlay.loading = false;
      this.merchandiseOverlay.mutation0Error = false;
    },
    async descriptionSectionData(): Promise<void> {
      // Fetch Image from MediaLibraryMS based on descriptionImageId
      // TODO WEB-2524
      const getImage = `https://i.ringana.com/2021/04/FRESH_soap_wildrose.png?q=100&w228&h228`;
      this.descriptionData = {
        image: getImage,
        shortDescription: this.singleProductData.shortDescription,
        usp: this.singleProductData.usp,
      };
    },
    async fetchBlogPosts(): Promise<void> {
      try {
        this.blogPosts = await this.$zApiService.getBlogPosts(this.singleProductData.blogPostsIds, 3, CookieHelper.getLanguage());
      } catch (err) {
        ErrorHandlerHelper.handleError(`Not able to load blog posts`, { logToConsole: true, showSwal: false });
      }
    },
    async fetchIdealSupplements(): Promise<void> {
      const matchcodes = this.singleProductData.idealSupplements.map(item => (item.matchcode));
      const matchcodesQuery = `/?matchcodes[]=${matchcodes.join(`&matchcodes[]=`)}`;

      const fetchResult = await FetchHelper.get({ path: `${config.api.paths.products.basepath}${matchcodesQuery}` });
      if(fetchResult.success) {
        this.productInfos = fetchResult.data;
        for(const product of this.productInfos) {
          for(const idealSupplement of this.singleProductData.idealSupplements) {
            if(idealSupplement.matchcode === product.matchcode) {
              product.description = idealSupplement.description;
            }
          }
        }
      } else {
        ErrorHandlerHelper.handleError(fetchResult, { logToConsole: true, showSwal: true });
      }
    },
    async fetchProductDetails(): Promise<void> {
      const wpProductData = await this.$wpApiService.getExtendedSingleProductData(
        window.location.href.split(`/`)[4],
        CookieHelper.getLanguage(),
        window.vueSingleProductLinks.imagesBaseUrl,
      );
      this.transformSingleProductData(wpProductData);
      await this.fetchIdealSupplements();
      try {
        this.zapiProductData = await this.$productService.getProductInfos(wpProductData.matchcode);
        this.productDetails = ProductHelper.transformZapiProductAndPapiProductToProductDetails(this.zapiProductData, this.singleProductData);
      } catch (err) {
        if(err instanceof ApplicationError && err.info?.errorCode === ErrorCodes.NOT_FOUND) {
          this.productNotFound = true;
          window.location.href = `/404`;
        } else {
          throw err;
        }
      }
      this.transformProductDetails(wpProductData);
    },
    async fetchSingleProductData(): Promise<void> {
      this.singleProductData = {
        awards: null,
        blogPostsIds: [],
        categories: [],
        descriptionImageId: -1,
        disruptor: {
          id: -1,
          mediaId: -1,
        },
        faqs: [],
        idealSupplements: [],
        informationLinkColor: ``,
        isCosmeticsProduct: false,
        productVariants: [],
        shortDescription: ``,
        tabs: [],
        teaserDots: [],
        title: ``,
        unitPriceData: {
          amount: null,
          type: null,
        },
        usp: ``,
        values: [],
      };
    },
    async fetchVideo(): Promise<void> {
      // Fetch Video from MediaLibraryMS based on disruptor.id
      // TODO: WEB-2898 Fetch Video from MediaLibrary MS
      this.video = {
        description: `Description`,
        poster: `https://i.ringana.com/2021/05/Sport_boost_banner.jpg?fm=jpg&auto=format`,
        url: `https://rin-wp-media.s3.eu-central-1.amazonaws.com/2018%2F04%2FBjaxsc2b-Moo-Ringana-Sports-neu_web.mp4`,
      };
    },
    async openMerchandiseOverlay(item: IMerchandiseItem): Promise<void> {
      this.merchandiseOverlay.isBusinessCard = await this.$productService.isBusinessCard(item);
      this.merchandiseOverlay.isCarDecal = await this.$productService.isCarDecal(item);
      this.merchandiseOverlay.visible = true;
      this.merchandiseOverlay.item = item;
      this.setTemporaryMerchandiseOverlayMutations();
    },
    print(content: string): void {
      const printWindow = window.open(``, `PRINT`, `height=400,width=600`);

      if(printWindow) {
        printWindow.document.write(`<html><body>`);
        printWindow.document.write(`<h1>${this.singleProductData.title}</h1>`);
        printWindow.document.write(content);
        printWindow.document.write(`</body></html>`);

        printWindow.document.close();
        printWindow.focus();

        printWindow.print();
        printWindow.close();
      }
    },
    async selectProductVariant(variant: IProductVariant): Promise<void> {
      const link = window.location.href.split(`/`);
      link[4] = variant.slug;
      window.location.href = link.join(`/`);
    },
    setMerchandiseOverlayMutations(): void {
      if(!this.merchandiseOverlay.item) {
        return;
      }
      for(const index of Object.keys(this.merchandiseOverlay.item.tempMutations)) {
        this.$set(this.merchandiseOverlay.item.mutations[+index], `value`, this.merchandiseOverlay.item.tempMutations[+index].value);
      }
    },
    setTemporaryMerchandiseOverlayMutations(): void {
      if(!this.merchandiseOverlay.item) {
        return;
      }
      this.$set(this.merchandiseOverlay.item, `tempMutations`, []);
      for(const index of Object.keys(this.merchandiseOverlay.item.mutations)) {
        this.$set(this.merchandiseOverlay.item.tempMutations, index, { id: index, value: this.merchandiseOverlay.item.mutations[+index].value });
      }
    },
    async setUp(): Promise<void> {
      [this.isPartner, this.availableCarts] = await Promise.all([
        CustomerHelper.getPartnerStatus(),
        this.$cartService.getCarts(),
        this.descriptionSectionData(),
        this.fetchVideo(),
        this.fetchBlogPosts(),
        this.fetchProductDetails(),
      ]);
      this.selectedCartId = this.availableCarts.find(cart => cart.name === `myOwnCart`)?.cartId ?? -1;
      this.pageLoading = false;
    },
    transformProductDetails(wpProductData: IExtendedSingleProductData): void {
      if(this.productDetails) {
        this.productDetails.images = wpProductData.productImages;
      }
      this.descriptionData = {
        image: wpProductData.productImageAlternative,
        shortDescription: wpProductData.shortDescription,
        usp: wpProductData.usp,
      };

      if(wpProductData.productVideoData.video && wpProductData.productVideoData.poster) {
        this.video = {
          description: `Description`,
          poster: wpProductData.productVideoData.poster,
          url: wpProductData.productVideoData.video,
        };
      } else {
        this.video = null;
      }
    },
    transformSingleProductData(wpProductData: IExtendedSingleProductData): void {
      this.singleProductData = {
        ...wpProductData,
        blogPostsIds: [],
        categories: [{
          id: +wpProductData.category,
          infoColorNeeded: !!wpProductData.informationLinkColor,
          name: ``,
          primary: !!wpProductData.informationLinkColor,
        }],
        descriptionImageId: -1,
        disruptor: { id: 0, mediaId: 0 },
        isCosmeticsProduct: wpProductData.productType === EProductType.FRISCHEKOSMETIK,
        tabs: [],
        unitPriceData: wpProductData.unitPriceData,
      };
      this.singleProductData.tabs.push({
        description: wpProductData.tabsData.description,
        id: 0,
        order: 0,
        showPrintButton: false,
        title: this.$t(`products-overview:tabs.description`),
      });
      this.singleProductData.tabs.push({
        description: wpProductData.type === `1` ? wpProductData.tabsData.ingredients : wpProductData.tabsData.statutoryTable,
        id: 1,
        order: 1,
        showPrintButton: true,
        title: wpProductData.type === `1` ? this.$t(`products-overview:tabs.ingredients`) : this.$t(`products-overview:tabs.ingredientsAndSpecifications`),
      });
      this.singleProductData.tabs.push({
        description: wpProductData.tabsData.knowHow,
        id: 2,
        order: 2,
        showPrintButton: false,
        title: this.$t(`products-overview:tabs.naturalTalents`),
      });
      this.singleProductData.tabs.push({
        description: wpProductData.tabsData.howTo,
        id: 3,
        order: 3,
        showPrintButton: false,
        title: this.$t(`products-overview:tabs.usage`),
      });
      for(let articleId = 0; articleId < 3; articleId++) {
        const article = wpProductData.interestingArticles[articleId];
        if(article.image !== `` && article.headline !== `` && article.link !== ``) {
          this.blogPosts.shift();
          this.blogPosts.push({
            category: ``,
            headerImage: null,
            id: articleId,
            keywords: ``,
            languageCode: ``,
            partnerCategory: ``,
            partnerExclusive: false,
            partnerProductImage: null,
            postType: ``,
            previewImage: wpProductData.interestingArticles[articleId].image,
            productImage: wpProductData.interestingArticles[articleId].image,
            title: wpProductData.interestingArticles[articleId].headline,
            url: wpProductData.interestingArticles[articleId].link,
          });
        }
      }
    },
    async updateBusinessCard(): Promise<void> {
      if(!this.areAllRequiredFieldsFilledOut() || !this.merchandiseOverlay.item) {
        return;
      }
      this.merchandiseOverlay.loading = true;
      await this.setMerchandiseOverlayMutations();
      const { item } = this.merchandiseOverlay;
      if(!item) {
        return;
      }

      try {
        await this.$cartService.updateItem(CartHelper.preparePatchCartItemRequestData(item));
        this.$swal(``, this.$t(`products-overview:editSuccess`), `success`);
      } catch (err) {
        ErrorHandlerHelper.handleError(err as Error, { showSwal: true });
      }

      this.closeMerchandiseOverlay(false);
    },
    updateLimitingActive(): void {
      this.limiting.active = true;
    },
    updateLimitingNotActive(): void {
      this.limiting.active = false;
    },
    updateLimitingPosition(event: { detail: ILimitingPosition }): void {
      this.limiting.position = event.detail;
    },
    async updateShoppingAllowed(): Promise<void> {
      this.limiting.shoppingAllowed = true;
    },
    updateShoppingDisallowed(): void {
      this.limiting.shoppingAllowed = false;
    },
  },
});
